import { AuthenticatedUserData } from "@code/authzed-common/src/queries/authenticateduser";
import React from "react";

/**
 * CurrentUserContext holds the current user.
 */
export const CurrentUserContext = React.createContext<AuthenticatedUserData | undefined>(undefined);
